import { BaseEntityResource } from '@/modules/core/app/resources/BaseEntityResource';
import { RouteGroup } from '@/modules/core/app/constants/api.constants';
import { SmartCampaign } from '@/modules/ta/smartcampaign/models/SmartCampaign';
import { CampaignPreview } from '@/modules/ta/smartcampaign/models/CampaignPreview';
import { DataView } from '@/modules/core/datasource/models/DataView';
import { apiAxios } from '@/modules/core/app/helpers/AxiosHelper';

export class SmartCampaignResource extends BaseEntityResource {
  constructor() {
    super(RouteGroup.SMARTCAMPAIGNS, SmartCampaign);
  }

  /**
   * @param {string} serviceId
   * @param params
   * @returns {Promise<DataView[]>}
   * */
  async getDataViews(serviceId, params = {}) {
    return super.getData(DataView, `services/${serviceId}/dataviews`, params);
  }

  /**
   * @param serviceId
   * @param dataViewId
   * @param customerId
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  async getCampaignPreviews(serviceId, dataViewId, customerId, params) {
    let route = `preview/data/${serviceId}/${dataViewId}`;
    if (customerId) {
      route += `/${customerId}`;
    }
    const data = await this.apiHelper.post(this._buildRoute(route), params);
    return this.extractData(data, CampaignPreview, params);
  }

  /**
   * @param serviceIds
   * @param customerId
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  async getFilteringCampaignPreviews(serviceIds, customerId, params) {
    const route = `preview/filteringData/${customerId}`;
    params.service_ids = `${serviceIds}`;
    const data = await this.apiHelper.post(this._buildRoute(route), params);
    return this.extractData(data, CampaignPreview, params);
  }

  /**
   * @param params
   * @returns {Promise<*>}
   */
  async getCampaignPreviewColumns(params) {
    return super.getColumns('preview/columns', params);
  }

  /**
   *
   * @param params
   * @returns {*}
   */
  getFilteredSmartCampaigns(params = {}) {
    return super.getData(SmartCampaign, 'filter_clients', params);
  }

  /**
   *
   * @param smartCampaignId
   * @returns {Promise<{string}>}
   */
  async getUsages(smartCampaignId) {
    return apiAxios.get(`/${this.routeGroup}/usage/${smartCampaignId}`);
  }

  /**
   *
   * @returns {Promise<void>}
   */
  exportList() {
    return this.download(`customexport`);
  }

  /**
   * @param id
   * @param params
   * @param config
   * @returns {Promise<*>}
   */
  async getForm(id, params = {}, config = {}) {
    const [item, columns, mapping] = await Promise.all([
      id ? this.getItem(id, params, config) : new this.model(),
      this.getColumns(null, params, config),
      id ? this.getRealMapping(id) : [],
    ]);

    if (id) item.real_mapping = mapping;
    return id ? [item, columns] : [item, columns, mapping];
  }

  /**
   *
   * @param smartCampaignId
   * @returns {Promise<{string}>}
   */
  async getRealMapping(smartCampaignId) {
    return apiAxios.get(`/${this.routeGroup}/mapping/${smartCampaignId}`);
  }
}

export default new SmartCampaignResource();
